import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalOpenerComponent } from './modal-opener.component';
import { IconModule } from '../icon/icon.module';
import { ModalModule } from '../modal/modal.module';



@NgModule({
  declarations: [ModalOpenerComponent],
  imports: [
    CommonModule,
    IconModule,
    ModalModule
  ],
  exports: [ModalOpenerComponent]
})
export class ModalOpenerModule { }
